import React from 'react'
import styles from './Buttons.module.css'
import { Button } from '@material-ui/core'
import cx from 'classnames'

const Buttons = () => {
  return (
    <div className={styles.container}>
      <Button
        variant='contained'
        href='#'
        className={cx(styles.btn, styles.btnProceed)}
      >
        Proceed to Payment
      </Button>
      <Button href='#' className={cx(styles.btn, styles.btnCancel)}>
        Cancel Order
      </Button>
    </div>
  )
}

export default Buttons
